<!-- @format -->

@if (productRecommendations?.length > 0) {
	<div
		id="pdp-ds-product-recommendations"
		[ngClass]="{
			'hmf-mb-m-l': isPLA() && !homefieldCarouselEnabled(),
			'p hmf-mb-l hmf-mb-m-xl': !homefieldCarouselEnabled()
		}"
		class="product-recommendations">
		<!-- Recommendation Heading -->
		@if (showHeading()) {
			<div
				class="header3 product-recommendations-header"
				[ngClass]="{
					'hmf-mb-m':
						!enableRepositionRecommendations() &&
						!isPLA() &&
						!homefieldCarouselEnabled(),
					'hmf-mb-s': isPLA(),
					'hmf-mb-xxxs hmf-ml-0': homefieldCarouselEnabled()
				}">
				<span [ngClass]="{ capitalized: capitalizeTitle() }">{{ displayName() }}</span>
				@if (showViewAllLink()) {
					<hr class="header-hr" />
				}
				@if (showViewAllLink()) {
					<a
						href="/s/recommended-for-you"
						class="hmf-ml-xxs viewall"
						data-em="PDP_CertonaViewAllpdplanding_rr"
						>View All</a
					>
				}
			</div>
		}
		@if (homefieldCarouselEnabled()) {
			<!-- Homefield Cart Recommendations -->
			<hmf-carousel
				actionButtonTitle="View All"
				[title]="title() ? title() : ''"
				[showHeader]="showHeader()"
				[showActionButton]="showViewAllLink()"
				(actionButtonClicked)="goToRecommendedForYouDS()">
				@for (
					itemRecomendation of productRecommendations;
					let index = $index;
					let isLast = $last;
					track trackByName(index, itemRecomendation)
				) {
					<div>
						@if (index < dsRecsProductDisplayLimit) {
							<hmf-product-card
								class="cursor-pointer"
								buttonStyle="secondary"
								[buttonText]="atcButtonTexts.atc"
								[ngClass]="!isLast && this.pageType() === 'Cart' ? '' : 'hmf-mr-xs'"
								[productData]="mapItemToProductCardData(itemRecomendation)"
								[showATC]="showATC"
								[showReviewsStars]="false"
								[size]="getProductCardSize()"
								variant="recommendation"
								(cardClicked)="onRecommendationLinkClick(itemRecomendation, index)"
								(addToCartClicked)="
									onAddToCartButtonClick(itemRecomendation, index)
								">
							</hmf-product-card>
						}
					</div>
				}
			</hmf-carousel>
		} @else {
			<!-- Legacy Cart Recommendations -->
			<div>
				<div
					class="hmf-display-flex hmf-flex-row cart-product-recommendation-card-container"
					[ngClass]="{
						'hmf-pt-s': enableRepositionRecommendations(),
						'hmf-pt-0 hmf-pb-xxs': isPLA()
					}">
					@for (item of productRecommendations; track $index + item?.name) {
						@let index = $index;
						@if (item) {
							<div
								class="product-recommendation dcsg-card"
								[ngClass]="{ 'hmf-p-s': isPLA() }"
								[class.small-mobile-product-recommendations]="
									smallLegacyMobileCard()
								">
								<span
									class="hmf-display-flex hmf-flex-column hmf-justify-content-evenly hmf-h-100">
									<a
										class="product-recommendation-content hmf-display-flex hmf-flex-column hmf-align-items-stretch hmf-align-self-stretch url"
										[ngClass]="{
											'product-recommendation-content-height': !isPLA()
										}"
										href="javascript:void(0)"
										(click)="onRecommendationLinkClick(item, index)">
										<img
											class="hmf-align-self-center cross-sell-img product-image"
											[ngClass]="{ 'hmf-mb-0': isPLA() }"
											loading="lazy"
											[src]="item?.image"
											[alt]="item?.seo?.imageAltDesc || item?.name" />
										<div
											class="cross-sell-desc product-name line-clamp hmf-align-self-start">
											<span [innerHTML]="item?.name"></span>
										</div>
										<div class="list-view-item-price hmf-align-self-start">
											<!-- "see price in cart" scenario -->
											@if (
												(!item?.prices?.minofferprice &&
													!item?.prices?.maxofferprice) ||
												item?.prices?.mapPriceIndicator === 1
											) {
												<span>See Price In Cart</span>
											}
											<!-- NOT "see price in cart" scenario -->
											@if (
												!(
													(!item?.prices?.minofferprice &&
														!item?.prices?.maxofferprice) ||
													item?.prices?.mapPriceIndicator === 1
												)
											) {
												<div>
													<span>{{
														item?.prices?.minofferprice | currency
													}}</span>
													@if (
														item?.prices?.minofferprice !==
														item?.prices?.maxofferprice
													) {
														<span
															>&nbsp;to&nbsp;{{
																item?.prices?.maxofferprice
																	| currency
															}}</span
														>
													}
												</div>
											}
										</div>
									</a>
									@if (showATC) {
										<div class="hmf-w-100 rec-atc">
											<button
												hmf-button
												variant="tertiary"
												class="rec-atc-btn"
												(click)="onAddToCartButtonClick(item, index)">
												{{ atcButtonTexts.atc }}
											</button>
										</div>
									}
								</span>
							</div>
						} @else {
							<hmf-skeleton
								[class.hmf-display-none]="smallLegacyMobileCard()"
								[class.hmf-display-md-block]="smallLegacyMobileCard()"
								[loading]="!item"
								height="219px"
								width="200px" />
							@if (smallLegacyMobileCard()) {
								<hmf-skeleton
									class="hmf-display-block hmf-display-md-none"
									[loading]="!item"
									height="175px"
									width="144px" />
							}
						}
					}
				</div>
			</div>
		}
	</div>
}
